import React from 'react';
import styled from 'styled-components';

import Button from '../Components/Button';
import Dialog from '../Components/Dialog';
import useI18n from '../i18n';
import { Item as CartItem } from '@baemingo/shopping-cart-events/dist/types';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background: #fff;
  border-radius: 24px;
`;

const Title = styled.h2`
  font-size: 16px;
  letter-spacing: 0.24px;
  line-height: 24px;
`;

const Items = styled.div`
  padding: 10px 0;
  max-height: 350px;
  overflow: auto;
`;

const Item = styled.div`
  max-height: 350px;
  overflow: auto;
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: 10px 0 0 0;
  align-items: center;
  justify-content: center;
`;

type Props = {
  isMenuExpired?: boolean;
  isItemsExpired?: boolean;
  onConfirm: () => void;
  expiredItems?: CartItem[];
};

const MenuExpiredModal = ({ isMenuExpired, isItemsExpired, onConfirm, expiredItems }: Props) => {
  const { i18n } = useI18n();
  return (
    <>
      <Dialog visible={Boolean(isMenuExpired)} onClose={onConfirm} dontCloseOnClickAnywhere>
        <Wrapper>
          <Title>{i18n('Cart.Modal.MenuExpired')}</Title>
          <ButtonContainer>
            <Button text={i18n('Cart.Confirm')} handleClick={onConfirm} small />
          </ButtonContainer>
        </Wrapper>
      </Dialog>

      <Dialog visible={Boolean(isItemsExpired)} onClose={onConfirm} dontCloseOnClickAnywhere>
        <Wrapper>
          <Title>{`${i18n('Cart.Modal.MenuItemsExpired')}:`}</Title>
          <Items>
            {expiredItems?.map((item) => (
              <Item key={`expired_item_${item.id}`}>{item.title}</Item>
            ))}
          </Items>
          <ButtonContainer>
            <Button text={i18n('Cart.Confirm')} handleClick={onConfirm} small />
          </ButtonContainer>
        </Wrapper>
      </Dialog>
    </>
  );
};

export default MenuExpiredModal;
